import { render } from "./BenefitOrders.vue?vue&type=template&id=627b2c8a&scoped=true"
import script from "./BenefitOrders.vue?vue&type=script&lang=js"
export * from "./BenefitOrders.vue?vue&type=script&lang=js"

import "./BenefitOrders.vue?vue&type=style&index=0&id=627b2c8a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627b2c8a"]])

export default __exports__